import { FC, ReactElement, Suspense } from 'react';

import { Loader } from '@mopla/ui';

const LazyRoute: FC<{ children: ReactElement }> = ({ children }) => (
	<Suspense fallback={<Loader delay={100} />}>{children}</Suspense>
);

export default LazyRoute;
